<template>
  <div>
    <b-card-text><strong>{{ $t('เงื่อนไขการเเทง') }}</strong></b-card-text>
    <b-table
      :tbody-tr-class="lockedRowClass"
      responsive
      bordered
      :fields="$tFields(fields)"
      :items="items"
    >
      <template #cell(type)="data">
        <div class="type-cell">
          {{ $tDisplay(betTypeLabel(data.value, options)) }}
          <feather-icon
            v-if="isLocked(data.value)"
            v-b-tooltip.hover
            :title="$t('fourFiveDigit.lockedYeekee')"
            icon="LockIcon"
            class="type-lock"
          />
        </div>
      </template>
      <template #cell(min)="data">
        <div
          class="hintEdit"
          @click="editData(data.index,'min')"
        >
          {{ data.value }}
        </div>
      </template>
      <template #cell(maxPerTime)="data">
        <div
          class="hintEdit"
          @click="editData(data.index,'maxPerTime')"
        >
          {{ data.value }}
        </div>
      </template>
      <template #cell(maxPerNumber)="data">
        <div
          class="hintEdit"
          @click="editData(data.index,'maxPerNumber')"
        >
          {{ data.value }}
        </div>
      </template>
    </b-table>

    <div class="text-right">
      <b-button
        v-if="$can('update', 'lotto.rate')"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mt-1"
        @click.prevent="saveEdit"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
        />
        <span class="align-middle">{{ $t('Submit') }}</span>
      </b-button>
    </div>

    <b-modal
      v-model="showModal"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('Ok')"
      centered
      size="xs"
      :title="$t('เเก้ไข')"
      button-size="sm"
      @ok="submitEdit"
      @hidden="modalTextError=''"
    >
      <b-form-input
        v-model="modalText"
        autofocus
        type="number"
        @keypress.enter="submitEdit"
      />
      <small
        v-if="modalTextError !== ''"
        class="text-danger"
      >{{ modalTextError }}</small>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable dot-notation */

import {
  BButton, BCardText, BFormInput, BModal, BTable, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import lottoService from '@/service/lottoService'
import { betTypeLabel, splitNewRateRows, isLockedFourFiveDigit } from '@/utils/betTypes'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BTable,
    BButton,
    BModal,
    BFormInput,
    BCardText,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    // 4/5 ตัว: ประเภทที่แก้ได้ (ติ๊กเปิดในยี่กีแล้ว) · ประเภทใหม่ที่ไม่อยู่ในนี้แสดงอย่างเดียว
    editableTypes: {
      type: Array,
      default: () => [],
    },
    huayCondition: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      options: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
        'เลขชุดสี่ตัว',
      ],
      fields: [
        {
          key: 'type',
          label: 'ประเภท',
          class: 'text-nowrap text-center',
        },
        {
          key: 'min',
          label: 'แทงขั้นต่ำต่อครั้ง',
          class: 'text-center text-nowrap',
          formatter: v => this.$store.state.app.toNumber(v),
        },
        {
          key: 'maxPerTime',
          label: 'เเทงสูงสุดต่อครั้ง',
          class: 'text-center text-nowrap',
          formatter: v => this.$store.state.app.toNumber(v),
        },
        {
          key: 'maxPerNumber',
          label: 'แทงสูงสุดต่อเลข',
          class: 'text-center text-nowrap',
          formatter: v => this.$store.state.app.toNumber(v),
        },
      ],
      items: [],
      focusableObj: {
        row: 0,
        key: '',
      },
      showModal: false,
      modalText: '',
      modalTextError: '',
    }
  },
  mounted() {
    this.items = this.huayCondition
  },
  methods: {
    betTypeLabel,
    isLocked(type) {
      return isLockedFourFiveDigit(type, this.editableTypes)
    },
    lockedRowClass(item) {
      return item && this.isLocked(item.type) ? 'text-muted' : ''
    },
    editData(row, key) {
      if (this.isLocked(this.items[row].type)) return
      this.showModal = true
      this.focusableObj.row = row
      this.focusableObj.key = key
      this.modalText = this.items[row][key]
    },
    submitEdit(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.modalText * 1 < 0) {
        this.modalTextError = this.$t('ตัวเลขต้องมีค่าตั้งเเต่ 0 ขึ้นไป')
      } else {
        const {
          row,
          key,
        } = this.focusableObj
        this.items[row][key] = this.modalText
        this.showModal = false
      }
    },
    saveEdit() {
      // 4/5 ตัว: แถวใหม่ที่ยังไม่แตะไม่ส่ง · แถวที่แตะแล้วต้องมีเงื่อนไขครบ
      const { rows, incomplete } = splitNewRateRows(this.huayCondition)
      if (incomplete.length > 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('เกิดข้อผิดพลาด'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: `${this.$t('ตั้งเงื่อนไขการแทงให้ครบก่อนบันทึก')}: ${incomplete.map(type => this.$tDisplay(betTypeLabel(type))).join(', ')}`,
          },
        })
        return
      }
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v of rows) {
              v.min *= 1
              v.maxPerTime *= 1
              v.maxPerNumber *= 1
            }
            const res = await lottoService.putAuthen(
              'rate/condition/yeekee',
              rows,
            )
            if (res.status === 200) {
              this.$emit('save')

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('บันทึกข้อมูสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
// ไอคอนล็อกวางทับขอบขวาของช่อง ไม่ดันชื่อประเภท แถวที่ล็อกจึงตรงกับแถวอื่น (เหมือน LottoCondition)
.type-cell {
  position: relative;
}

.type-lock {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
